
import { action } from "typesafe-actions";
import { call, put, takeLatest } from "redux-saga/effects";

import { Model, StateProps, ModelProps } from "./model"
import { FilterParamsInterface, FilterViewParams, ResultDb } from "../services/db";
import { getNewId, isEmpty } from "../services/utils";


enum Actions {
    create = `@CREATE`,
    read = `@READ`,
    readView = `@READ_VIEW`,
    update = `@UPDATE`,
    deletar = `@DELETE`,
    get = `@GET`,
    set = `@SET`,
    setClearValue = "@SET_CLEAR_VALUE",
    setShowAlert = `@SET_SHOW_ALERT`,
    setShowDialogExluir = `@SET_SHOW_DIALOG_EXCLUIR`,
    setShowCadModal = `@SET_SHOW_CAD_MODAL`,
    setShowSelectModal = `@SET_SHOW_SELECT_MODAL`,
    setShowMsg = `@SET_SHOW_MSG`,
    waiting = `@WAITING`,
    resultAfterEffcts = `@RESULT_AFTER_EFFECTS`,
    addAnexoDoc = `@ADD_ANEXO_DOC`,
    remAnexoDoc = `@REM_ANEXO_DOC`
}

export interface Dispatch<dataProps> {
    create: (row: dataProps) => any,
    read: (arg?: FilterParamsInterface) => any,
    readView: (arg: FilterViewParams) => any
    update: (row: dataProps) => any,
    deletar: (row: dataProps) => any,
    get: (id: any) => any,
    set: (row: dataProps) => any,
    setClearValue: () => any,
    waiting: (set: boolean, msg: string) => any
    setShowAlert: (set: boolean) => any
    setShowDialogExluir: (set: boolean) => any
    setShowCadModal: (set: boolean) => any
    setShowSelectModal: (set: boolean) => any
    setShowMsg: (msg: string, type: string) => any
    addAnexoDoc: (prm: { row: any; anexo: Blob; anexo_id?: string }) => any
    remAnexoDoc: (prm: { row: any; anexo_id: string }) => any
}

export interface Payload {
    payload: any,
    type: string
}

export interface ReducerProps<
    dataProps, stateProps, dispatchActions extends Dispatch<dataProps>
> {
    actions: dispatchActions,
    reduceState: (state: stateProps, action: any) => any
    resultAfterEffects: (result: stateProps, actionsTypeCalled: any) => any
}


export class Controller<
    dataProps extends ModelProps,
    stateProps extends StateProps<dataProps>,
    dispatchActions extends Dispatch<dataProps>
>
    extends Model<dataProps, stateProps> {

    public INITIAL_STATE: stateProps;
    public reducer: ReducerProps<dataProps, stateProps, dispatchActions>;
    public actionsType: any
    public actionEffects: any

    constructor(moduloName: string, initialState: stateProps,) {
        super(moduloName)
        this.setInitialValueState(initialState)
        this.setProps(initialState.row);
        this.INITIAL_STATE = initialState;
        this.actionsType = {
            create: `@${moduloName}/${Actions.create}`,
            read: `@${moduloName}/${Actions.read}`,
            readView: `@${moduloName}/${Actions.readView}`,
            update: `@${moduloName}/${Actions.update}`,
            deleta: `@${moduloName}/${Actions.deletar}`,
            get: `@${moduloName}/${Actions.get}`,
            set: `@${moduloName}/${Actions.set}`,
            setClearValue: `@${moduloName}/${Actions.setClearValue}`,
            setShowAlert: `@${moduloName}/${Actions.setShowAlert}`,
            setShowDialogExluir: `@${moduloName}/${Actions.setShowDialogExluir}`,
            setShowCadModal: `@${moduloName}/${Actions.setShowCadModal}`,
            setShowSelectModal: `@${moduloName}/${Actions.setShowSelectModal}`,
            setShowMsg: `@${moduloName}/${Actions.setShowMsg}`,
            waiting: `@${moduloName}/${Actions.waiting}`,
            resultAfterEffcts: `@${moduloName}/${Actions.resultAfterEffcts}`,
            addAnexoDoc: `@${moduloName}/${Actions.addAnexoDoc}`,
            remAnexoDoc: `@${moduloName}/${Actions.remAnexoDoc}`,
        };

        this.reducer = {
            actions: {
                create: (row: dataProps) => action(this.actionsType.create, { row, this: this }),
                read: (arg?: FilterParamsInterface) => action(this.actionsType.read, { arg, this: this }),
                readView: (arg: FilterViewParams) => action(this.actionsType.readView, { arg, this: this }),
                update: (row: dataProps) => action(this.actionsType.update, { row, this: this }),
                deletar: (row: dataProps) => action(this.actionsType.deleta, { row, this: this }),

                get: (id: any) => action(this.actionsType.get, { id, this: this }),
                set: (row: dataProps) => action(this.actionsType.set, { row, this: this }),
                setClearValue: () => action(this.actionsType.setClearValue),
                setShowAlert: (set: boolean) => action(this.actionsType.setShowAlert, { set, this: this }),
                setShowDialogExluir: (set: boolean) => action(this.actionsType.setShowDialogExluir, { set, this: this }),
                setShowCadModal: (set: boolean) => action(this.actionsType.setShowCadModal, { set, this: this }),
                setShowSelectModal: (set: boolean) => action(this.actionsType.setShowSelectModal, { set }),
                setShowMsg: (msg: string, type: string) => action(this.actionsType.setShowMsg, { msg, type }),
                waiting: (set: boolean, msg: string) => action(this.actionsType.waiting, { set, msg, this: this }),
                addAnexoDoc: (prm: { row: any; anexo: Blob; anexo_id?: string }) => action(this.actionsType.addAnexoDoc, { prm, this: this }),
                remAnexoDoc: (prm: { row: any; anexo_id: string }) => action(this.actionsType.remAnexoDoc, { prm, this: this }),

            } as dispatchActions,
            reduceState: (state = this.INITIAL_STATE, action) => {
                switch (action.type) {
                    case this.actionsType.create:
                        return this.setState({ ...state, loading: true, error: false, msg: `Adicionando registro de ${this.moduloName}, aguarde...`, status: "" });
                    case this.actionsType.read:
                        return this.setState({ ...state, loadingRows: true, error: false, msg: `Filtrando registros de ${this.moduloName}, aguarde...`, status: "" });
                    case this.actionsType.readView:
                        return this.setState({ ...state, loadingRows: true, error: false, msg: `Buscando dados de ${this.moduloName}, aguarde...`, status: "" });
                    case this.actionsType.update:
                        return this.setState({ ...state, loading: true, error: false, msg: `Atualizando registro de ${this.moduloName}, Aguarde...`, status: "" });
                    case this.actionsType.deleta:
                        return this.setState({ ...state, loading: true, error: false, msg: `Excluindo registro de ${this.moduloName}, aguarde...`, status: "" });

                    case this.actionsType.get:
                        return this.setState({ ...state, loading: true, error: false, msg: `Buscando ${this.moduloName}, aguarde...`, status: "" });
                    case this.actionsType.set:
                        return this.setState({ ...state, row: { ...structuredClone(this.INITIAL_STATE.row), ...action.payload.row } });
                    case this.actionsType.setClearValue:
                        return this.setState({ ...state, row: { ...structuredClone(this.INITIAL_STATE.row) } });
                    case this.actionsType.setShowAlert:
                        return this.setState({ ...state, showAlert: action.payload.set });
                    case this.actionsType.setShowDialogExluir:
                        return this.setState({ ...state, showDialogExluir: action.payload.set })
                    case this.actionsType.setShowCadModal:
                        return this.setState({ ...state, showCadModal: action.payload.set })
                    case this.actionsType.setShowSelectModal:
                        return this.setState({ ...state, showSelectModal: action.payload.set })
                    case this.actionsType.setShowMsg:
                        return this.setState({ ...state, showAlert: true, msg: action.payload.msg, status: action.payload.type })
                    case this.actionsType.resultAfterEffcts:
                        return this.setState({ ...state, ...action.payload.result })
                    case this.actionsType.addAnexoDoc:
                        return this.setState({ ...state, loading: true, msg: `Adicionando anexo, aguarde...`, error: false, status: "" })
                    case this.actionsType.remAnexoDoc:
                        return this.setState({ ...state, loading: true, msg: `Removendo anexo, aguarde...`, error: false, status: "" })
                    default:
                        return this.setState(state);
                }
            },
            resultAfterEffects: (result, actionType) => action(this.actionsType.resultAfterEffcts, { result, actionType, this: this })
        };

        this.actionEffects = [
            takeLatest(this.actionsType.create, this.createEffects),
            takeLatest(this.actionsType.get, this.getEffects),
            takeLatest(this.actionsType.read, this.readEffects),
            takeLatest(this.actionsType.readView, this.readViewEffects),
            takeLatest(this.actionsType.update, this.updateEffects),
            takeLatest(this.actionsType.deleta, this.deleteEffects),
            takeLatest(this.actionsType.addAnexoDoc, this.addAnexoDocEffects),
            takeLatest(this.actionsType.remAnexoDoc, this.remAnexoDocEffects),
        ]
    }

    private * createEffects(actions: Payload) {
        const vm = actions.payload.this as Controller<dataProps, stateProps, dispatchActions>;
        try {
            let row: dataProps = actions.payload.row;
            let resp: ResultDb<dataProps> = yield call(vm.db.salvar, row);
            if (resp.status === "ok" && resp.row) {
                let rows: dataProps[] = [...vm.state.rows];
                rows.push(resp.row)
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loading: false, msg: resp.msg, row: resp.row, rows: rows, status: resp.status, changeList: new Date().toISOString() },
                    vm.actionsType.create
                ))
            } else {
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loading: false, msg: resp.msg, status: "error", error: true, showAlert: true },
                    vm.actionsType.create
                ))
            }
        } catch (error: any) {
            let msg = "Ops, ocorreu uma falha em createEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.create
            ))

        }
    }

    private * getEffects(actions: Payload) {
        const vm = actions.payload.this as Controller<dataProps, stateProps, dispatchActions>;
        try {
            let id = actions.payload.id;
            let resp: ResultDb<dataProps> = yield call(vm.db.getDocID, id);
            if (resp.status === "ok") {
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loading: false, msg: resp.msg, row: resp.row, status: resp.status },
                    vm.actionsType.get
                ))
            } else {
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loading: false, msg: resp.msg, status: "error", error: true, showAlert: true },
                    vm.actionsType.get
                ))
            }
        } catch (error: any) {
            let msg = "Ops, ocorreu uma falha em getEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.get
            ))
        }
    }

    private * readEffects(actions: Payload) {
        const vm = actions.payload.this as Controller<dataProps, stateProps, dispatchActions>;
        const arg: FilterParamsInterface = actions.payload.arg;
        try {
            let resp: ResultDb<dataProps> = yield call(vm.read, arg);
            if (resp.status === "ok") {
                let row = vm.state.row;
                if (!isEmpty(row._rev) && (resp.rows?.length ?? 0) > 0) {
                    let index = resp.rows?.findIndex((rowFind) => rowFind._id === row._id);
                    row = resp.rows && index !== undefined && index >= 0 ? resp.rows[index] : row;
                    yield put(vm.reducer.resultAfterEffects(
                        { ...vm.state, loadingRows: false, msg: resp.msg, rows: resp.rows, row: row, status: resp.status, changeList: new Date().toISOString() },
                        vm.actionsType.read
                    ))
                } else {
                    yield put(vm.reducer.resultAfterEffects(
                        { ...vm.state, loadingRows: false, msg: resp.msg, rows: resp.rows, status: resp.status, changeList: new Date().toISOString() },
                        vm.actionsType.read
                    ))
                }
            } else {
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loadingRows: false, msg: resp.msg, status: "error", error: true, showAlert: true },
                    vm.actionsType.read
                ))
            }
        } catch (error: any) {
            let msg = "Ops, ocorreu uma falha em readEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loadingRows: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.read
            ))
        }
    }

    read = async (arg?: FilterParamsInterface) => {
        try {
            let filterDoc: FilterParamsInterface = {
                fieldsFilter: [
                    { fieldName: "type", fieldValue: this.moduloName, mangoQuery: "$eq" }
                ],
                indexName: `idx_doc_type_${this.moduloName}`
            }
            if (arg) {
                filterDoc.fieldsFilter = filterDoc.fieldsFilter.concat(arg.fieldsFilter);
                filterDoc.indexName = arg.indexName;
                filterDoc.limit = arg.limit;
            }
            console.log("filterdoc", filterDoc);
            return await this.db.filter(filterDoc)
        } catch (error) {
            return error
        }
    }

    private * readViewEffects(actions: Payload) {
        const vm = actions.payload.this as Controller<dataProps, stateProps, dispatchActions>;
        const arg: FilterViewParams = actions.payload.arg;
        try {
            let resp: ResultDb<dataProps> = yield call(vm.readView, arg);
            console.log("resp readViewEffects", resp);
            if (resp.status === "ok") {
                let row = vm.state.row;
                console.log("vm.state.row", row);
                if (!isEmpty(row._rev) && (resp.rows?.length ?? 0) > 0) {
                    let index = resp.rows?.findIndex((rowFind) => rowFind._id === row._id);
                    row = resp.rows && index !== undefined && index >= 0 ? resp.rows[index] : row;
                    console.log("achou row", row);
                    yield put(vm.reducer.resultAfterEffects(
                        { ...vm.state, loadingRows: false, msg: resp.msg, rows: resp.rows, row: row, status: resp.status, changeList: new Date().toISOString() },
                        vm.actionsType.readView
                    ))
                } else {
                    console.log("nao achou row");
                    yield put(vm.reducer.resultAfterEffects(
                        { ...vm.state, loadingRows: false, msg: resp.msg, rows: resp.rows, status: resp.status, changeList: new Date().toISOString() },
                        vm.actionsType.readView
                    ))
                }
            } else {
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loadingRows: false, msg: resp.msg, status: "error", error: true, showAlert: true },
                    vm.actionsType.readView
                ))
            }
        } catch (error: any) {
            let msg = "Ops, ocorreu uma falha em readView, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loadingRows: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.readView
            ))
        }
    }


    readView = async (arg: FilterViewParams) => {
        try {
            console.log("readView params", arg)
            return await this.db.filterView(arg)
        } catch (error) {
            return error
        }
    }

    private * updateEffects(actions: Payload) {
        let vm = actions.payload.this as Controller<dataProps, stateProps, dispatchActions>;
        try {
            console.log("chamou updateEffects", actions);
            let row: dataProps = { ...actions.payload.row };
            let resp: ResultDb<dataProps> = yield call(vm.db.salvar, row);
            console.log("resp updateEffects", resp);
            if (resp.status === "ok" && resp.row) {
                let rows: dataProps[] = [...vm.state.rows];
                let idx = rows.findIndex(rowFind => (
                    rowFind._id === row._id
                ))
                rows[idx] = resp.row;
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loading: false, msg: resp.msg, row: resp.row, rows: rows, status: resp.status, changeList: new Date().toISOString() },
                    vm.actionsType.update
                ))
            } else {
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loading: false, msg: resp.msg, status: "error", error: true, showAlert: true },
                    vm.actionsType.update
                ))
            }
        } catch (error: any) {
            let msg = "Ops, ocorreu uma falha em updateEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.update
            ))
        }
    }

    private * deleteEffects(actions: Payload) {
        let vm = actions.payload.this as Controller<dataProps, stateProps, dispatchActions>;
        try {
            console.log("chamou deleteEffects", actions);
            let row: dataProps = { ...actions.payload.row };
            let resp: ResultDb<dataProps> = yield call(vm.db.deleteData, row);
            if (resp.status === "ok") {
                let rows: dataProps[] = [...vm.state.rows];
                let idx = rows.findIndex(rowFind => rowFind._id === row._id)
                rows.splice(idx, 1);
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loading: false, msg: resp.msg, row: vm.initialState.row, rows: rows, status: resp.status, changeList: new Date().toISOString() },
                    vm.actionsType.deleta
                ))
            } else {
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loading: false, msg: resp.msg, status: "error", error: true, showAlert: true },
                    vm.actionsType.deleta
                ))
            }
        } catch (error: any) {
            console.log("error ", error);
            let msg = "Ops, ocorreu uma falha em deleteEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.deleta
            ))
        }
    }

    private * addAnexoDocEffects(actions: Payload) {
        let vm = actions.payload.this as Controller<dataProps, stateProps, dispatchActions>;
        try {
            console.log("chamou addAnexoDocEffects", actions);
            let row = actions.payload.prm.row;
            let anexo = actions.payload.prm.anexo;
            let anexo_id = actions.payload.prm.anexo_id;
            let resp: ResultDb<dataProps> = yield call(vm.db.addAnexoDoc, row, anexo, anexo_id);
            if(resp.status === "ok"){
                yield put(vm.reducer.actions.get(row._id));
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loading: false, msg: resp.msg, status: resp.status },
                    vm.actionsType.addAnexoDoc
                ))
            } else {
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loading: false, msg: resp.msg, status: "error", error: true, showAlert: true },
                    vm.actionsType.addAnexoDoc
                ))
            }

        } catch (error: any) {
            console.log("error ", error);
            let msg = "Ops, ocorreu uma falha em addAnexoDocEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.addAnexoDoc
            ))
        }
    }

    private * remAnexoDocEffects(actions: Payload) {
        let vm = actions.payload.this as Controller<dataProps, stateProps, dispatchActions>;
        try {
            console.log("chamou remAnexoDocEffects", actions);
            let row = actions.payload.prm.row;
            let anexo = actions.payload.prm.anexo;
            let anexo_id = actions.payload.prm.anexo_id;
            let resp: ResultDb<dataProps> = yield call(vm.db.removerAnexoDoc, row._id,anexo_id, row._rev);
            if(resp.status === "ok"){
                yield put(vm.reducer.actions.get(row._id));
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loading: false, msg: resp.msg, status: resp.status },
                    vm.actionsType.remAnexoDoc
                ))
            } else {
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loading: false, msg: resp.msg, status: "error", error: true, showAlert: true },
                    vm.actionsType.remAnexoDoc
                ))
            }

        } catch (error: any) {
            console.log("error ", error);
            let msg = "Ops, ocorreu uma falha em remAnexoDocEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.remAnexoDoc
            ))
        }
    }    

}